import React from 'react';
import SearchableSelect from './components/SearchableSelect';

// 自定义比较函数，只有comp.id、value、onChange变化才重渲
// eslint-disable-next-line no-unused-vars
function areEqual(prev, next) {
  // 对于验房品牌组件，需要比较选项变化
  if (prev.comp.type === 'inspection_brand' || next.comp.type === 'inspection_brand') {
    const prevOptions = JSON.stringify(prev.comp.props?.options || []);
    const nextOptions = JSON.stringify(next.comp.props?.options || []);
    return prev.comp.id === next.comp.id && 
           prev.value === next.value && 
           prev.onChange === next.onChange &&
           prevOptions === nextOptions;
  }
  
  return prev.comp.id === next.comp.id && prev.value === next.value && prev.onChange === next.onChange;
}

const FormItem = function FormItem({ comp, value, onChange }) {
  // 移动端优化的通用输入框样式
  const mobileInputStyle = {
    width: '100%',
    padding: '14px 16px',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    fontSize: '16px', // 移动端推荐16px避免缩放
    background: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'all 0.2s ease',
    WebkitAppearance: 'none', // 移除iOS默认样式
    appearance: 'none'
  };

  // 移动端优化的选择框样式
  const mobileSelectStyle = {
    ...mobileInputStyle,
    backgroundImage: 'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'16\' height=\'16\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23666\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'6,9 12,15 18,9\'%3E%3C/polyline%3E%3C/svg%3E")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    backgroundSize: '16px',
    paddingRight: '40px'
  };

  // 统一提前声明所有 inputRef，避免 hooks 条件调用
  const inspectionTimeRef = React.useRef(null);
  const activityTimeRef = React.useRef(null);
  const dateRef = React.useRef(null);
  const timeRef = React.useRef(null);

  switch (comp.type) {
    case 'input':
    case 'member_name':
    case 'member_phone':
    case 'building_number':
    case 'vip_card_number':
    case 'inspection_community':
      return (
        <input
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入'}
          type="text"
          style={{
            ...mobileInputStyle,
            ...(comp.type === 'member_phone' && { inputMode: 'tel' }),
            ...(comp.type === 'member_name' && { inputMode: 'text' }),
            ...(comp.type === 'building_number' && { inputMode: 'text' }),
            ...(comp.type === 'vip_card_number' && { inputMode: 'text' }),
            ...(comp.type === 'inspection_community' && { inputMode: 'text' })
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'house_area':
      return (
        <input
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入房屋面积'}
          type="number"
          style={{
            ...mobileInputStyle,
            inputMode: 'decimal'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'member_community':
      return (
        <input
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入小区'}
          type="text"
          style={mobileInputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'activity_community':
      return (
        <input
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入活动小区'}
          type="text"
          style={mobileInputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'textarea':
      return (
        <textarea
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入'}
          style={{
            ...mobileInputStyle,
            minHeight: '100px',
            maxHeight: '300px',
            resize: 'vertical',
            lineHeight: '1.5',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'number':
      return (
        <input
          type="number"
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入数字'}
          style={{
            ...mobileInputStyle,
            inputMode: 'numeric'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'select':
      return (
        <select
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          style={mobileSelectStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        >
          <option value="">{comp.props?.placeholder || '请选择'}</option>
          {(comp.props?.options || []).map((opt, idx) => (
            <option key={typeof opt === 'object' ? opt.id || opt.name : idx} value={typeof opt === 'object' ? opt.name : opt}>{typeof opt === 'object' ? opt.name : opt}</option>
          ))}
        </select>
      );
    case 'radio':
      const radioOptions = comp.props?.options || [];
      if (radioOptions.length === 0) {
        return (
          <div style={{ 
            padding: '12px', 
            background: '#fff2e8', 
            border: '1px solid #ffbb96', 
            borderRadius: '8px',
            color: '#d46b08',
            fontSize: '14px'
          }}>
            单选组件：暂无选项，请在属性面板中添加选项
          </div>
        );
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {radioOptions.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = value === optionValue;
            return (
              <div 
                key={typeof opt === 'object' ? opt.id || opt.name : idx} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  padding: '12px 16px',
                  background: isChecked ? '#e6f7ff' : '#f8f9fa',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: isChecked ? '2px solid #667eea' : '2px solid transparent'
                }}
                onClick={() => onChange(comp.id, optionValue)}
              >
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '2px solid #667eea',
                    background: isChecked ? '#667eea' : 'transparent',
                    position: 'relative',
                    cursor: 'pointer'
                  }}
                >
                  {isChecked && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#fff'
                      }}
                    />
                  )}
                </div>
                <span style={{ fontSize: '16px', color: '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
    case 'checkbox': {
      const checkboxOptions = comp.props?.options || [];
      if (checkboxOptions.length === 0) {
        return (
          <div style={{ 
            padding: '12px', 
            background: '#fff2e8', 
            border: '1px solid #ffbb96', 
            borderRadius: '8px',
            color: '#d46b08',
            fontSize: '14px'
          }}>
            多选组件：暂无选项，请在属性面板中添加选项
          </div>
        );
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {checkboxOptions.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = Array.isArray(value) && value.includes(optionValue);
            return (
              <div
                key={typeof opt === 'object' ? opt.id || opt.name : idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  background: isChecked ? '#e6f7ff' : '#f8f9fa',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: isChecked ? '2px solid #667eea' : '2px solid transparent'
                }}
                onClick={() => {
                  let newValues = Array.isArray(value) ? value.slice() : [];
                  if (isChecked) {
                    newValues = newValues.filter(v => v !== optionValue);
                  } else {
                    // 检查是否达到最大选择数量
                    const maxSelection = comp.props?.maxSelection || 0;
                    if (maxSelection === 0 || newValues.length < maxSelection) {
                      if (!newValues.includes(optionValue)) newValues.push(optionValue);
                    }
                  }
                  onChange(comp.id, newValues);
                }}
              >
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '6px',
                    border: '2px solid #667eea',
                    background: isChecked ? '#667eea' : 'transparent',
                    position: 'relative',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {isChecked && (
                    <div
                      style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '2px',
                        background: '#fff',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                      }}
                    />
                  )}
                </div>
                <span style={{ fontSize: '16px', color: '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
    }
    case 'switch':
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 0' }}>
          <div
            style={{ 
              width: '48px', 
              height: '28px', 
              background: value ? '#667eea' : '#d9d9d9', 
              borderRadius: '14px', 
              position: 'relative', 
              cursor: 'pointer',
              transition: 'background 0.2s ease'
            }}
            onClick={() => onChange(comp.id, !value)}
          >
            <div style={{ 
              width: '24px', 
              height: '24px', 
              background: '#fff', 
              borderRadius: '50%', 
              position: 'absolute', 
              top: '2px', 
              left: value ? '22px' : '2px', 
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)', 
              transition: 'left 0.2s ease' 
            }}></div>
          </div>
          <span style={{ color: '#666', fontSize: '16px' }}>开关状态</span>
        </div>
      );
    case 'inspection_time': {
      const inspectionInputType = comp.props?.allowTime ? 'datetime-local' : 'date';
      // iOS 兼容性处理：确保值为有效格式
      let normalizedValue = '';
      if (value) {
        if (typeof value === 'string') {
          const trimmed = value.trim();
          // 如果是 datetime-local，确保格式正确 (YYYY-MM-DDTHH:mm)
          if (inspectionInputType === 'datetime-local') {
            // 检查是否符合 ISO 8601 格式
            if (trimmed.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/)) {
              normalizedValue = trimmed;
            } else if (trimmed.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/)) {
              // 转换 "YYYY-MM-DD HH:mm" 格式为 "YYYY-MM-DDTHH:mm"
              normalizedValue = trimmed.replace(' ', 'T');
            }
          } else {
            // date 类型，确保格式为 YYYY-MM-DD
            if (trimmed.match(/^\d{4}-\d{2}-\d{2}$/)) {
              normalizedValue = trimmed;
            }
          }
        } else if (typeof value === 'number') {
          // 如果是时间戳，转换为 ISO 格式
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            if (inspectionInputType === 'datetime-local') {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              normalizedValue = `${year}-${month}-${day}T${hours}:${minutes}`;
            } else {
              normalizedValue = date.toISOString().split('T')[0];
            }
          }
        }
      }
      
      return (
        <div
          style={{ position: 'relative', width: '100%', cursor: 'pointer' }}
          onClick={e => {
            if (e.target.tagName !== 'INPUT') {
              inspectionTimeRef.current && inspectionTimeRef.current.focus();
            }
          }}
        >
          <input
            ref={inspectionTimeRef}
            type={inspectionInputType}
            value={normalizedValue}
            onChange={e => {
              const newValue = e.target.value || '';
              onChange(comp.id, newValue);
            }}
            step={inspectionInputType === 'datetime-local' ? '60' : undefined}
            style={{ ...mobileInputStyle, paddingRight: 40, cursor: 'pointer' }}
            onFocus={e => {
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      );
    }
    case 'activity_time': {
      const inputType = comp.props?.allowTime ? 'datetime-local' : 'date';
      // iOS 兼容性处理：确保值为有效格式
      let normalizedValue = '';
      if (value) {
        if (typeof value === 'string') {
          const trimmed = value.trim();
          // 如果是 datetime-local，确保格式正确 (YYYY-MM-DDTHH:mm)
          if (inputType === 'datetime-local') {
            // 检查是否符合 ISO 8601 格式
            if (trimmed.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/)) {
              normalizedValue = trimmed;
            } else if (trimmed.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/)) {
              // 转换 "YYYY-MM-DD HH:mm" 格式为 "YYYY-MM-DDTHH:mm"
              normalizedValue = trimmed.replace(' ', 'T');
            }
          } else {
            // date 类型，确保格式为 YYYY-MM-DD
            if (trimmed.match(/^\d{4}-\d{2}-\d{2}$/)) {
              normalizedValue = trimmed;
            }
          }
        } else if (typeof value === 'number') {
          // 如果是时间戳，转换为 ISO 格式
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            if (inputType === 'datetime-local') {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              const hours = String(date.getHours()).padStart(2, '0');
              const minutes = String(date.getMinutes()).padStart(2, '0');
              normalizedValue = `${year}-${month}-${day}T${hours}:${minutes}`;
            } else {
              normalizedValue = date.toISOString().split('T')[0];
            }
          }
        }
      }
      
      return (
        <div
          style={{ position: 'relative', width: '100%', cursor: 'pointer' }}
          onClick={e => {
            if (e.target.tagName !== 'INPUT') {
              activityTimeRef.current && activityTimeRef.current.focus();
            }
          }}
        >
          <input
            ref={activityTimeRef}
            type={inputType}
            value={normalizedValue}
            onChange={e => {
              const newValue = e.target.value || '';
              onChange(comp.id, newValue);
            }}
            step={inputType === 'datetime-local' ? '60' : undefined}
            style={{ ...mobileInputStyle, paddingRight: 40, cursor: 'pointer' }}
            onFocus={e => {
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      );
    }
    case 'date': {
      // iOS 兼容性处理：确保值为有效格式 (YYYY-MM-DD)
      let normalizedValue = '';
      if (value) {
        if (typeof value === 'string') {
          const trimmed = value.trim();
          // 确保格式为 YYYY-MM-DD
          if (trimmed.match(/^\d{4}-\d{2}-\d{2}$/)) {
            normalizedValue = trimmed;
          } else if (trimmed.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
            // 转换 "YYYY/MM/DD" 格式为 "YYYY-MM-DD"
            normalizedValue = trimmed.replace(/\//g, '-');
          }
        } else if (typeof value === 'number') {
          // 如果是时间戳，转换为 ISO 格式
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            normalizedValue = date.toISOString().split('T')[0];
          }
        }
      }
      
      return (
        <div
          style={{ position: 'relative', width: '100%', cursor: 'pointer' }}
          onClick={e => {
            if (e.target.tagName !== 'INPUT') {
              dateRef.current && dateRef.current.focus();
            }
          }}
        >
          <input
            ref={dateRef}
            type="date"
            value={normalizedValue}
            onChange={e => {
              const newValue = e.target.value || '';
              onChange(comp.id, newValue);
            }}
            style={{ ...mobileInputStyle, paddingRight: 40, cursor: 'pointer' }}
            onFocus={e => {
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      );
    }
    case 'time': {
      // 确保值为有效格式，无效值使用空字符串
      const normalizedValue = value && (typeof value === 'string' || typeof value === 'number') 
        ? String(value).trim() 
        : '';
      return (
        <div
          style={{ position: 'relative', width: '100%', cursor: 'pointer' }}
          onClick={e => {
            if (e.target.tagName !== 'INPUT') {
              timeRef.current && timeRef.current.focus();
            }
          }}
        >
          <input
            ref={timeRef}
            type="time"
            value={normalizedValue || ''}
            onChange={e => onChange(comp.id, e.target.value || '')}
            style={{ ...mobileInputStyle, paddingRight: 40, cursor: 'pointer' }}
            onFocus={e => {
              e.target.style.borderColor = '#667eea';
              e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      );
    }
    case 'datetime':
    case 'inspection_datetime': {
      // 确保值为有效格式，无效值使用空字符串
      const normalizedValue = value && (typeof value === 'string' || typeof value === 'number') 
        ? String(value).trim() 
        : '';
      return (
        <input
          type="datetime-local"
          value={normalizedValue || ''}
          onChange={e => onChange(comp.id, e.target.value || '')}
          style={mobileInputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    }
    case 'member_brand_merchant':
      return (
        <SearchableSelect
          value={value}
          onChange={(newValue) => onChange(comp.id, newValue)}
          options={comp.props?.options || []}
          placeholder={comp.props?.placeholder || '请选择品牌商家'}
          style={mobileSelectStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'inspection_brand': {
      const options = comp.props?.options || [];
      if (options.length === 0) {
        return (
          <div style={{ 
            padding: '12px', 
            background: '#fff2e8', 
            border: '1px solid #ffbb96', 
            borderRadius: '8px',
            color: '#d46b08',
            fontSize: '14px'
          }}>
            验房品牌组件：暂无选项，请在属性面板中添加选项
          </div>
        );
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {options.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = Array.isArray(value) && value.includes(optionValue);
            return (
              <div
                key={typeof opt === 'object' ? opt.id || opt.name : idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '12px 16px',
                  background: isChecked ? '#e6f7ff' : '#f8f9fa',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: isChecked ? '2px solid #667eea' : '2px solid transparent'
                }}
                onClick={() => {
                  let newValues = Array.isArray(value) ? value.slice() : [];
                  if (isChecked) {
                    newValues = newValues.filter(v => v !== optionValue);
                  } else {
                    // 检查是否达到最大选择数量
                    const maxSelection = comp.props?.maxSelection || 0;
                    if (maxSelection === 0 || newValues.length < maxSelection) {
                      if (!newValues.includes(optionValue)) newValues.push(optionValue);
                    }
                  }
                  onChange(comp.id, newValues);
                }}
              >
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '6px',
                    border: '2px solid #667eea',
                    background: isChecked ? '#667eea' : 'transparent',
                    position: 'relative',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {isChecked && (
                    <div
                      style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '2px',
                        background: '#fff',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                      }}
                    />
                  )}
                </div>
                <span style={{ fontSize: '16px', color: '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
    }
    case 'activity_brand':
      // 复用inspection_brand的渲染逻辑
      const abOptions = comp.props?.options || [];
      if (abOptions.length === 0) {
        return (
          <div style={{ 
            padding: '12px', 
            background: '#fff2e8', 
            border: '1px solid #ffbb96', 
            borderRadius: '8px',
            color: '#d46b08',
            fontSize: '14px'
          }}>
            活动品牌组件：暂无选项，请在属性面板中添加选项
          </div>
        );
      }
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {abOptions.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = value === optionValue;
            return (
              <div 
                key={typeof opt === 'object' ? opt.id || opt.name : idx} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '12px',
                  padding: '12px 16px',
                  background: isChecked ? '#e6f7ff' : '#f8f9fa',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: isChecked ? '2px solid #667eea' : '2px solid transparent'
                }}
                onClick={() => onChange(comp.id, optionValue)}
              >
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: '2px solid #667eea',
                    background: isChecked ? '#667eea' : 'transparent',
                    position: 'relative',
                    cursor: 'pointer'
                  }}
                >
                  {isChecked && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: '#fff'
                      }}
                    />
                  )}
                </div>
                <span style={{ fontSize: '16px', color: '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
    case 'activity_brand_multi':
      // 品牌多选组件
      const abmOptions = comp.props?.options || [];
      const valueArr = (value || '').split(',').filter(Boolean);
      
      if (abmOptions.length === 0) {
        return (
          <div style={{ 
            padding: '12px', 
            background: '#fff2e8', 
            border: '1px solid #ffbb96', 
            borderRadius: '8px',
            color: '#d46b08',
            fontSize: '14px'
          }}>
            品牌多选组件：暂无选项，请在属性面板中添加选项
          </div>
        );
      }
      
      return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', flexWrap: 'wrap' }}>
          {abmOptions.map((opt, idx) => {
            const optionValue = typeof opt === 'object' ? opt.name : opt;
            const isChecked = valueArr.includes(optionValue);
            return (
              <div 
                key={typeof opt === 'object' ? opt.id || opt.name : idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 12px',
                  background: isChecked ? '#1890ff' : '#f8f9fa',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  border: isChecked ? '2px solid #1890ff' : '2px solid transparent',
                  minWidth: 'fit-content'
                }}
                onClick={() => {
                  let newArr = valueArr.slice();
                  if (isChecked) {
                    newArr = newArr.filter(v => v !== optionValue);
                  } else {
                    // 检查是否达到最大选择数量
                    const maxSelection = comp.props?.maxSelection || 0;
                    if (maxSelection === 0 || newArr.length < maxSelection) {
                      newArr.push(optionValue);
                    }
                  }
                  onChange(comp.id, newArr.join(','));
                }}
              >
                <span style={{ fontSize: '16px', color: isChecked ? '#fff' : '#333' }}>{optionValue}</span>
              </div>
            );
          })}
        </div>
      );
    case 'image':
      return (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '16px', 
          textAlign: 'center',
          backgroundColor: '#fafafa',
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onClick={() => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {
              onChange(comp.id, file.name);
            }
          };
          input.click();
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#667eea';
          e.target.style.backgroundColor = '#f0f8ff';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = '#d9d9d9';
          e.target.style.backgroundColor = '#fafafa';
        }}
        >
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🖼️</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击选择图片</div>
          {value && <div style={{ color: '#52c41a', fontSize: '12px', marginTop: '8px' }}>已选择: {value}</div>}
        </div>
      );
    case 'image-multi':
      return (
        <div style={{ 
          border: '2px dashed #d9d9d9', 
          borderRadius: '8px', 
          padding: '16px', 
          textAlign: 'center',
          backgroundColor: '#fafafa',
          cursor: 'pointer',
          transition: 'all 0.2s ease'
        }}
        onClick={() => {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.multiple = true;
          input.onchange = (e) => {
            const files = Array.from(e.target.files);
            if (files.length > 0) {
              const fileNames = files.map(f => f.name).join(', ');
              onChange(comp.id, fileNames);
            }
          };
          input.click();
        }}
        onMouseEnter={(e) => {
          e.target.style.borderColor = '#667eea';
          e.target.style.backgroundColor = '#f0f8ff';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderColor = '#d9d9d9';
          e.target.style.backgroundColor = '#fafafa';
        }}
        >
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🖼️🖼️</div>
          <div style={{ color: '#666', fontSize: '14px' }}>点击选择多张图片</div>
          {value && <div style={{ color: '#52c41a', fontSize: '12px', marginTop: '8px' }}>已选择: {value}</div>}
        </div>
      );
    case 'richtext':
      return (
        <div style={{ 
          border: '1px solid #d9d9d9', 
          borderRadius: '8px', 
          padding: '12px', 
          backgroundColor: '#fafafa', 
          minHeight: '100px',
          maxWidth: '100%',
          boxSizing: 'border-box'
        }}
        dangerouslySetInnerHTML={{ __html: value || comp.props?.value || '' }}
        />
      );
    case 'rate':
      return (
        <div style={{ display: 'flex', gap: 6 }}>
          {[1,2,3,4,5].map(star => (
            <span
              key={star}
              style={{
                fontSize: 28,
                color: value >= star ? '#faad14' : '#ddd',
                cursor: 'pointer'
              }}
              onClick={() => onChange(comp.id, star)}
            >★</span>
          ))}
        </div>
      );
    case 'slider':
      return (
        <input
          type="range"
          min={comp.props?.min || 0}
          max={comp.props?.max || 100}
          value={value || 0}
          onChange={e => onChange(comp.id, Number(e.target.value))}
          style={{ width: '100%' }}
        />
      );
    case 'signature':
      return (
        <div style={{ padding: 12, color: '#aaa', fontStyle: 'italic' }}>
          签名功能请在移动端或专用控件中实现
        </div>
      );
    case 'title':
      return (
        <div style={{ fontWeight: 700, fontSize: 20, margin: '16px 0 8px 0', color: '#222' }}>
          {comp.props?.text || '标题'}
        </div>
      );
    case 'description':
      return (
        <div style={{ color: '#888', fontSize: 15, margin: '8px 0 16px 0' }}>
          {comp.props?.text || '说明文字'}
        </div>
      );
    case 'shop_address':
      return (
        <input
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入店铺地址'}
          type="text"
          style={mobileInputStyle}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'inspection_remark':
    case 'activity_requirement':
      return (
        <textarea
          value={value}
          onChange={e => onChange(comp.id, e.target.value)}
          placeholder={comp.props?.placeholder || '请输入内容'}
          style={{
            ...mobileInputStyle,
            minHeight: '80px',
            maxHeight: '300px',
            resize: 'vertical',
            lineHeight: '1.5',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
          }}
          onFocus={(e) => {
            e.target.style.borderColor = '#667eea';
            e.target.style.boxShadow = '0 0 0 2px rgba(102, 126, 234, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#e0e0e0';
            e.target.style.boxShadow = 'none';
          }}
        />
      );
    case 'brand_store_cascader': {
      // 一对一：品牌-店铺地址
      const mapping = comp.props?.mapping || [];
      const selectedBrand = value?.brand || '';
      // 品牌列表
      const brands = mapping.map(item => (typeof item === 'object' ? item.brand : item));
      // 选中品牌的店铺地址
      // eslint-disable-next-line no-unused-vars
      const selectedStore = mapping.find(item => (typeof item === 'object' ? item.brand : item) === selectedBrand)?.store || '';
      return (
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', width: '100%' }}>
          <select
            value={selectedBrand}
            onChange={e => onChange(comp.id, { brand: e.target.value, store: mapping.find(item => (typeof item === 'object' ? item.brand : item) === e.target.value)?.store || '' })}
            style={{ ...mobileSelectStyle, flex: 1 }}
          >
            <option value="">请选择品牌商家</option>
            {brands.map((brand, idx) => (
              <option key={idx} value={brand}>{brand}</option>
            ))}
          </select>
        </div>
      );
    }
    default:
      console.warn('未处理的组件类型:', comp.type, comp);
      return (
        <div style={{ 
          padding: '12px', 
          background: '#f8f9fa', 
          border: '1px solid #dee2e6', 
          borderRadius: '8px',
          color: '#6c757d',
          fontSize: '14px'
        }}>
          未支持的组件类型: {comp.type}
        </div>
      );
  }
}

export default FormItem; 